// extracted by mini-css-extract-plugin
export default {"root":"item_groups-module___root___e5d76547","item":"item_groups-module___item___c5eaa2ed"};